import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count"]

  connect() {
    this.updateCount()
  }

  updateCount() {
    const remaining = 120 - this.inputTarget.value.length
    this.countTarget.textContent = remaining
  }
} 